import React, { Component } from 'react';

import Moment from 'react-moment';
import Table from 'components/table';
import profile from 'assets/svg/default_avatar.svg';
import Filters from './Filters';

import { connect } from 'react-redux';
import { Button, Row, Col } from 'reactstrap';
import { fetchUsers, updateStatus } from './_actions';
import PrivateHeader from 'components/layouts/PrivateHeader';

import Date from 'components/Date';

class Users extends Component {
  fetchUsers = options => {
    const { page, sort_by, search, status } = options;
    const { users } = this.props;

    const params = {
      page: page ? page : users.page,
      sort_by: sort_by ? sort_by : users.sort_by,
      sort_order: sort_by
        ? users.sort_order === 'asc' && sort_by === sort_by
          ? 'desc'
          : 'asc'
        : users.sort_order,
      search: search !== null && search !== undefined ? search : users.search,
      status: status
    };

    this.props.fetchUsers(params);
  };

  onStatus = status => {};

  updateStatus = user => {
    //API is not implemengted yet
    // const params = getValuesAsFormData({ id: user.id, verified: !user.verified }, true, false);
    // this.props.updateStatus(params);
  };

  componentDidMount() {
    this.fetchUsers({ page: 1 });
  }

  render() {
    const { users } = this.props;

    return (
      <div className="dash-wrapper">
        <PrivateHeader title={'Users'} />

        <div className="box-container pt-10">
          <Row className="table-wraper mt-1">
            <Col className="col-12 table-users">
              <Table
                extra={<Filters onChange={this.onStatus} />}
                searchPlaceholder="Find a user, intergrations"
                headers={[
                  { name: 'Name', label: 'name', sort: true },
                  { name: 'Email', label: 'email', sort: true },
                  { name: 'Mobile Number', label: 'mobile', sort: true },
                  { name: 'Aplications', label: 'applications', sort: true },
                  { name: 'Last Activity', label: 'last_activity', sort: true },
                  { name: 'Terms Accepted', label: 'terms_accepted_at', sort: true },
                  { name: 'Action', label: 'integration_id', sort: true }
                ]}
                columnWidths={['col-2', 'col-2 ', 'col-2', 'col-1', 'col-2', 'col-2', 'col-1']}
                rows={users.data.map(user => [
                  <div className={!user.verified ? 'not-verified' : ''}>
                    <Row>
                      <Col xs={'auto'} className="mr-0">
                        <div
                          className={`img-container ${!user.photo ? 'default' : ''}`}
                          style={{ backgroundImage: `url(${user.photo ? user.photo : profile})` }}
                        />
                      </Col>
                      <Col className="d-flex align-items-center">
                        <div> {user.name}</div>
                      </Col>
                    </Row>
                  </div>,
                  <span className={`text-lowercase ${!user.verified ? 'not-verified' : ''}`}>
                    {user.email}
                  </span>,
                  <span className={!user.verified ? 'not-verified' : ''}>{user.mobile}</span>,
                  '-',
                  <div className={!user.verified ? 'not-verified' : ''}>
                    <Date
                      date={user.last_directive ? user.last_directive.created_at : user.created_at}
                    />
                  </div>,
                  user.terms_accepted_at ? (
                    <div className={!user.verified ? 'not-verified' : ''}>
                      <Date date={user.terms_accepted_at} />
                    </div>
                  ) : (
                    '-'
                  ),
                  <Button
                    outline
                    className={`min-w-75`}
                    onClick={this.updateStatus.bind(this, user)}
                    color={!user.enabled ? 'success' : 'danger'}
                    disabled={true}
                  >
                    {!user.enabled ? 'Activate' : 'Deactivate'}
                  </Button>
                ])}
                defaultSort={{ sort_order: users.sort_order, sort_by: users.sort_by }}
                onSort={label => this.fetchUsers({ sort_by: label })}
                search={true}
                onSearch={search => this.fetchUsers({ page: 1, search })}
                pagination={{
                  total: ~~users.total,
                  current_page: ~~users.page,
                  last_page: users.total_pages
                }}
                onPageChange={page => this.fetchUsers({ page })}
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { users: state.users };
}

export default connect(
  mapStateToProps,
  { fetchUsers, updateStatus }
)(Users);



// WEBPACK FOOTER //
// ./src/views/users/index.js